import StatusTempAdd from './StatusTempAdd'
import ShowTextNote from './ShowTextNote'
import Attack1Attack from './Attack1Attack'
import CharacterBaseAction from './CharacterBaseAction'
import FreeAttackPhysicalAttack from './FreeAttackPhysicalAttack'
import FreeAttackBuffPhysicalAttack from './FreeAttackBuffPhysicalAttack'
import FreeAttackMagicalAttack from './FreeAttackMagicalAttack'
import FreeAttackBuffMagicalAttack from './FreeAttackBuffMagicalAttack'
import FreeHealNormalHeal from './FreeHealNormalHeal'
import FreeHealBuffHeal from './FreeHealBuffHeal'
import FreeBuffAdd from './FreeBuffAdd'
import FreeBuffAddStatus from './FreeBuffAddStatus'
import FreeBuffAddPower from './FreeBuffAddPower'
import FreePassiveBarrier from './FreePassiveBarrier'
import FreePassiveBuffBarrier from './FreePassiveBuffBarrier'
import FreePassiveProtect from './FreePassiveProtect'
import Hook from './Hook'
import LockHook from './LockHook'
import TargetingSerious from './TargetingSerious'
import TargetingUnequipBuff from './TargetingUnequipBuff'
import TargetingEquipBuff from './TargetingEquipBuff'
import BuffAdd from './BuffAdd'
import BuffCount from './BuffCount'
import BuffRemove from './BuffRemove'
import AiTurnCount from './AiTurnCount'
import AiCost from './AiCost'
import CharacterPassiveAction from './CharacterPassiveAction'
import PassiveGuard from './PassiveGuard'
import PassiveAvoid from './PassiveAvoid'
const iconKey = {
  'status.temp-add': require('@/assets/icon/temp-add.png'),
  'show.text-note': require('@/assets/icon/text-note.png'),
  'attack2.1-attack': require('@/assets/icon/physical-attack.png'),
  'free/attack.physical-attack': require('@/assets/icon/physical-attack.png'),
  'free/attack.buff-physical-attack': require('@/assets/icon/physical-attack.png'),
  'free/attack.magical-attack': require('@/assets/icon/magical-attack.png'),
  'free/attack.buff-magical-attack': require('@/assets/icon/magical-attack.png'),
  'free/buff.add': require('@/assets/icon/buff-add.png'),
  'free/buff.add-status': require('@/assets/icon/temp-add.png'),
  'free/buff.add-power': require('@/assets/icon/temp-add.png'),
  'free/heal.normal-heal': require('@/assets/icon/normal-heal.png'),
  'free/heal.buff-heal': require('@/assets/icon/normal-heal.png'),
  'free/passive.barrier': require('@/assets/icon/normal-heal.png'),
  'free/passive.buff-barrier': require('@/assets/icon/normal-heal.png'),
  'free/passive.protect': require('@/assets/icon/normal-heal.png')
}
const componentKey = {
  'status.temp-add': 'StatusTempAdd',
  'show.text-note': 'ShowTextNote',
  'attack2.1-attack': 'Attack1Attack',
  'free/attack.physical-attack': FreeAttackPhysicalAttack,
  'free/attack.buff-physical-attack': FreeAttackBuffPhysicalAttack,
  'free/attack.magical-attack': FreeAttackMagicalAttack,
  'free/attack.buff-magical-attack': FreeAttackBuffMagicalAttack,
  'free/heal.normal-heal': FreeHealNormalHeal,
  'free/heal.buff-heal': FreeHealBuffHeal,
  'free/buff.add': FreeBuffAdd,
  'free/buff.add-status': FreeBuffAddStatus,
  'free/buff.add-power': FreeBuffAddPower,
  'free/passive.barrier': FreePassiveBarrier,
  'free/passive.buff-barrier': FreePassiveBuffBarrier,
  'free/passive.protect': FreePassiveProtect,

  'card/common.declare': 'CommonDeclare',
  'card/common.cost': 'CommonCost',

  'passive.standby': 'PassiveStandby',

  'ai.change': 'AiChange',
  'ai.targeting': 'AiTargeting',
  'ai.exists': 'AiExists',
  'ai.turnCount': 'AiTurnCount',
  'ai.0-time': 'Ai0Time',
  'ai.cost': 'AiCost',

  'targeting.load-live-enemy': 'TargetingLoadLiveEnemy',
  'targeting.load-live-friend': 'TargetingLoadLiveFriend',
  'targeting.load-me': 'TargetingLoadMe',
  'targeting.serious': 'TargetingSerious',
  'targeting.without-me': 'TargetingWithoutMe',
  'targeting.unequip-buff': 'TargetingUnequipBuff',
  'targeting.equip-buff': 'TargetingEquipBuff',
  'targeting.focus-me': 'TargetingFocusMe',
  'character.count-skill-ai': 'CharacterCountSkillAi',

  'character.base-action': 'CharacterBaseAction',
  'dice.throw': 'DiceThrow',

  'buff2.add': 'BuffAdd',
  'buff2.remove': 'BuffRemove',
  'buff2.count': 'BuffCount',

  //next-count
  'character.passive-action': 'CharacterPassiveAction',

  'passive.guard': 'PassiveGuard',
  'passive.avoid': 'PassiveAvoid',

  'free/show.skill-performance': 'FreeShowSkillPerformance',

  //get
  'account/privilege.increase-max-character': 'AccountPrivilegeIncreaseMaxCharacter',
}
const componentTooltip = {
  'status.temp-add': 'キャラクターの能力値を一時的に増減します',
  'show.text-note': 'テキストを表示します'
}
const componentSubCode = {
  'free/attack.physical-attack': [{
    value:'onHit', label:'ヒット時'
  }],
  'free/attack.buff-physical-attack': [{
    value:'onHit', label:'ヒット時'
  }],
  'free/attack.magical-attack': [{
    value:'onHit', label:'ヒット時'
  }],
  'free/attack.buff-magical-attack': [{
    value:'onHit', label:'ヒット時'
  }],
}
const hookLabel = {
  'card/common.declare': 'カード使用宣言',
  'card/common.cost': 'カードを消費する',

  'passive.standby': '初期選択',

  'ai.change': '使用済切替',
  'ai.targeting': '対象抽出',
  'ai.exists': '対象確認',
  'ai.turnCount': '○ターン後',
  'ai.0-time': '０回使用',
  'ai.cost': '残りダイス数',

  'targeting.load-live-enemy': '敵対象',
  'targeting.load-live-friend': '味方対象',
  'targeting.load-me': '自己対象',
  'targeting.serious': '重傷',
  'targeting.without-me': '自分以外',
  'targeting.unequip-buff': 'バフ未付与',
  'targeting.equip-buff': 'バフ付与',
  'targeting.focus-me': '自己狙い',
  'character.count-skill-ai': '使用済みフラグ',

  'character.base-action': '行動宣言',
  'dice.throw': 'ダイスロール',

  'buff2.add': 'バフ付与',
  'buff2.count': 'バフカウント',
  'buff2.remove': 'バフ削除',

  //next-count
  'character.passive-action': '発動宣言',

  'passive.guard': '防御',
  'passive.avoid': '回避',

  'free/show.skill-performance': '演出再生',

  //get
  'account/privilege.increase-max-character': '最大キャラクター数増加',
}
const hookTooltip = {
  'card/common.declare': '○○を使った！とログに表示します',
  'card/common.cost': '使用回数を１回カウントします。残回数が０になると消滅します。',

  'passive.standby': '１ターン目に使用します。',

  'ai.change': '既に使用済みの場合はスキップします。一定の条件で使用済みフラグがリセットされます。',
  'ai.targeting': '以降で対象抽出系が使えるようになります。',
  'ai.exists': '抽出結果が0人の場合はスキップします。',
  'ai.turnCount': 'ターン数の条件を満たしていない場合はスキップします。',
  'ai.0-time': '使用しません。',
  'ai.cost': '残りのダイスの数が条件を満たしていない場合はスキップします。',

  'targeting.load-live-enemy': '対象範囲を敵全体で初期化します',
  'targeting.load-live-friend': '対象範囲を味方全体で初期化します',
  'targeting.load-me': '対象範囲を自己で初期化します',
  'targeting.serious': '対象範囲の重傷者を抽出します',
  'targeting.without-me': '対象範囲から自己を除きます',
  'targeting.unequip-buff': '対象範囲のバフ未付与者を抽出します',
  'targeting.equip-buff': '対象範囲のバフ付与者を抽出します',
  'targeting.focus-me': '自分を対象としている対象を抽出します',
  'character.count-skill-ai': 'カードを使用済みにします',

  'character.base-action': '行動開始・行動終了のログを出力し、次の行動を選択します。',
  'dice.throw': 'ダイスロールします。カスタム動作でダイス目を使うようになります。',

  'buff2.add': 'キャラクターにバフを付与します。',
  'buff2.count': 'バフのカウントを進めます。',
  'buff2.remove': 'キャラクターのバフを削除します。',

  //next-count
  'character.passive-action': '効果発動のログを出力します。',

  'passive.guard': '詠唱中防御状態になります。',
  'passive.avoid': '詠唱中回避状態になります。',

  'free/show.skill-performance': '演出を使用します。',

  //get
  'account/privilege.increase-max-character': '最大キャラクター数が増加します。',
}

export {
  iconKey,
  hookLabel,
  componentKey,
  hookTooltip,
  componentTooltip,
  componentSubCode
}
export default {
  components: {
    StatusTempAdd,
    ShowTextNote,
    Attack1Attack,
    FreeAttackPhysicalAttack,
    FreeAttackBuffPhysicalAttack,
    FreeAttackMagicalAttack,
    FreeAttackBuffMagicalAttack,
    FreeBuffAdd,
    FreeBuffAddStatus,
    FreeBuffAddPower,
    FreePassiveBarrier,
    FreePassiveBuffBarrier,
    FreePassiveProtect,
    FreeShowSkillPerformance: Hook,

    CommonDeclare: Hook,
    CommonCost: Hook,
    PassiveStandby: Hook,
    AiChange: LockHook,
    AiTargeting: Hook,
    AiExists: Hook,
    AiTurnCount,
    Ai0Time: Hook,
    AiCost,
    TargetingLoadLiveEnemy: Hook,
    TargetingLoadLiveFriend: Hook,
    TargetingLoadMe: Hook,
    TargetingSerious,
    TargetingWithoutMe: Hook,
    TargetingUnequipBuff,
    TargetingEquipBuff,
    TargetingFocusMe: Hook,
    CharacterCountSkillAi: LockHook,
    CharacterBaseAction,
    DiceThrow: Hook,

    BuffAdd,
    BuffCount,
    BuffRemove,

    CharacterPassiveAction,

    PassiveGuard,
    PassiveAvoid,

    AccountPrivilegeIncreaseMaxCharacter: Hook,
  },
}
